// Premium date+time selection without a new dependency (no date-picker
// library exists in this app today, and adding one just for this one
// field isn't warranted) - native <input type="date">/<input type="time">
// (already well-supported native pickers on mobile, unlike the combined
// datetime-local input's especially raw/inconsistent rendering) styled to
// match the app, PLUS a prominent human-readable summary line so the
// selected value never reads as raw browser chrome.
export function UnlockDateTimePicker({
  dateValue,
  timeValue,
  minDate,
  error,
  onDateChange,
  onTimeChange,
}: {
  dateValue: string; // yyyy-mm-dd
  timeValue: string; // HH:mm
  minDate: string; // yyyy-mm-dd
  error: string | null;
  onDateChange: (value: string) => void;
  onTimeChange: (value: string) => void;
}) {
  const summary = formatSummary(dateValue, timeValue);

  return (
    <div className="private-drop-datetime">
      <span className="private-drop-datetime-label">Unlock date & time</span>
      <div className="private-drop-datetime-inputs">
        <label className="private-drop-datetime-field">
          <i className="bi bi-calendar-event" aria-hidden="true" />
          <input type="date" value={dateValue} min={minDate} onChange={(e) => onDateChange(e.target.value)} aria-label="Choose unlock date" />
        </label>
        <label className="private-drop-datetime-field">
          <i className="bi bi-clock" aria-hidden="true" />
          <input type="time" value={timeValue} onChange={(e) => onTimeChange(e.target.value)} aria-label="Choose unlock time" />
        </label>
      </div>
      {summary && !error && <p className="private-drop-datetime-summary">Unlocks {summary}</p>}
      {error && (
        <p className="private-drop-datetime-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

function formatSummary(dateValue: string, timeValue: string): string | null {
  if (!dateValue || !timeValue) return null;
  const d = new Date(`${dateValue}T${timeValue}`);
  if (Number.isNaN(d.getTime())) return null;
  const dateStr = d.toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
  const timeStr = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return `${dateStr} at ${timeStr}`;
}
